/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TeamManagerRouteImport } from './routes/team-manager'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as LessonsRouteImport } from './routes/lessons'
import { Route as ChallengesRouteImport } from './routes/challenges'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LibraryIndexRouteImport } from './routes/library/index'
import { Route as LessonsIndexRouteImport } from './routes/lessons/index'
import { Route as ChallengesIndexRouteImport } from './routes/challenges/index'
import { Route as LibraryModuleSlugRouteImport } from './routes/library/$moduleSlug'
import { Route as LessonsSlugRouteImport } from './routes/lessons/$slug'
import { Route as DevLessonsRouteImport } from './routes/dev/lessons'
import { Route as ChallengesPageSlugRouteImport } from './routes/challenges/$pageSlug'
import { Route as DevLessonsIndexRouteImport } from './routes/dev/lessons/index'
import { Route as DevLessonsCategorySlugRouteImport } from './routes/dev/lessons/$category.$slug'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/welcome.lazy').then((d) => d.Route))
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamManagerRoute = TeamManagerRouteImport.update({
  id: '/team-manager',
  path: '/team-manager',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/team-manager.lazy').then((d) => d.Route))
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/library.lazy').then((d) => d.Route))
const LessonsRoute = LessonsRouteImport.update({
  id: '/lessons',
  path: '/lessons',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/lessons.lazy').then((d) => d.Route))
const ChallengesRoute = ChallengesRouteImport.update({
  id: '/challenges',
  path: '/challenges',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/challenges.lazy').then((d) => d.Route))
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/activate.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LibraryRoute,
} as any).lazy(() => import('./routes/library/index.lazy').then((d) => d.Route))
const LessonsIndexRoute = LessonsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LessonsRoute,
} as any)
const ChallengesIndexRoute = ChallengesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChallengesRoute,
} as any).lazy(() =>
  import('./routes/challenges/index.lazy').then((d) => d.Route),
)
const LibraryModuleSlugRoute = LibraryModuleSlugRouteImport.update({
  id: '/$moduleSlug',
  path: '/$moduleSlug',
  getParentRoute: () => LibraryRoute,
} as any).lazy(() =>
  import('./routes/library/$moduleSlug.lazy').then((d) => d.Route),
)
const LessonsSlugRoute = LessonsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => LessonsRoute,
} as any).lazy(() => import('./routes/lessons/$slug.lazy').then((d) => d.Route))
const DevLessonsRoute = DevLessonsRouteImport.update({
  id: '/dev/lessons',
  path: '/dev/lessons',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/dev/lessons.lazy').then((d) => d.Route))
const ChallengesPageSlugRoute = ChallengesPageSlugRouteImport.update({
  id: '/$pageSlug',
  path: '/$pageSlug',
  getParentRoute: () => ChallengesRoute,
} as any).lazy(() =>
  import('./routes/challenges/$pageSlug.lazy').then((d) => d.Route),
)
const DevLessonsIndexRoute = DevLessonsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevLessonsRoute,
} as any).lazy(() =>
  import('./routes/dev/lessons/index.lazy').then((d) => d.Route),
)
const DevLessonsCategorySlugRoute = DevLessonsCategorySlugRouteImport.update({
  id: '/$category/$slug',
  path: '/$category/$slug',
  getParentRoute: () => DevLessonsRoute,
} as any).lazy(() =>
  import('./routes/dev/lessons/$category.$slug.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin': typeof AdminRoute
  '/challenges': typeof ChallengesRouteWithChildren
  '/lessons': typeof LessonsRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/settings': typeof SettingsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/team-manager': typeof TeamManagerRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/welcome': typeof WelcomeRoute
  '/challenges/$pageSlug': typeof ChallengesPageSlugRoute
  '/dev/lessons': typeof DevLessonsRouteWithChildren
  '/lessons/$slug': typeof LessonsSlugRoute
  '/library/$moduleSlug': typeof LibraryModuleSlugRoute
  '/challenges/': typeof ChallengesIndexRoute
  '/lessons/': typeof LessonsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/dev/lessons/': typeof DevLessonsIndexRoute
  '/dev/lessons/$category/$slug': typeof DevLessonsCategorySlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin': typeof AdminRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/settings': typeof SettingsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/team-manager': typeof TeamManagerRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/welcome': typeof WelcomeRoute
  '/challenges/$pageSlug': typeof ChallengesPageSlugRoute
  '/lessons/$slug': typeof LessonsSlugRoute
  '/library/$moduleSlug': typeof LibraryModuleSlugRoute
  '/challenges': typeof ChallengesIndexRoute
  '/lessons': typeof LessonsIndexRoute
  '/library': typeof LibraryIndexRoute
  '/dev/lessons': typeof DevLessonsIndexRoute
  '/dev/lessons/$category/$slug': typeof DevLessonsCategorySlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin': typeof AdminRoute
  '/challenges': typeof ChallengesRouteWithChildren
  '/lessons': typeof LessonsRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/settings': typeof SettingsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/team-manager': typeof TeamManagerRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/welcome': typeof WelcomeRoute
  '/challenges/$pageSlug': typeof ChallengesPageSlugRoute
  '/dev/lessons': typeof DevLessonsRouteWithChildren
  '/lessons/$slug': typeof LessonsSlugRoute
  '/library/$moduleSlug': typeof LibraryModuleSlugRoute
  '/challenges/': typeof ChallengesIndexRoute
  '/lessons/': typeof LessonsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/dev/lessons/': typeof DevLessonsIndexRoute
  '/dev/lessons/$category/$slug': typeof DevLessonsCategorySlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/admin'
    | '/challenges'
    | '/lessons'
    | '/library'
    | '/privacy-policy'
    | '/settings'
    | '/sign-in'
    | '/sign-up'
    | '/team-manager'
    | '/terms-of-service'
    | '/welcome'
    | '/challenges/$pageSlug'
    | '/dev/lessons'
    | '/lessons/$slug'
    | '/library/$moduleSlug'
    | '/challenges/'
    | '/lessons/'
    | '/library/'
    | '/dev/lessons/'
    | '/dev/lessons/$category/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/admin'
    | '/privacy-policy'
    | '/settings'
    | '/sign-in'
    | '/sign-up'
    | '/team-manager'
    | '/terms-of-service'
    | '/welcome'
    | '/challenges/$pageSlug'
    | '/lessons/$slug'
    | '/library/$moduleSlug'
    | '/challenges'
    | '/lessons'
    | '/library'
    | '/dev/lessons'
    | '/dev/lessons/$category/$slug'
  id:
    | '__root__'
    | '/'
    | '/activate'
    | '/admin'
    | '/challenges'
    | '/lessons'
    | '/library'
    | '/privacy-policy'
    | '/settings'
    | '/sign-in'
    | '/sign-up'
    | '/team-manager'
    | '/terms-of-service'
    | '/welcome'
    | '/challenges/$pageSlug'
    | '/dev/lessons'
    | '/lessons/$slug'
    | '/library/$moduleSlug'
    | '/challenges/'
    | '/lessons/'
    | '/library/'
    | '/dev/lessons/'
    | '/dev/lessons/$category/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivateRoute: typeof ActivateRoute
  AdminRoute: typeof AdminRoute
  ChallengesRoute: typeof ChallengesRouteWithChildren
  LessonsRoute: typeof LessonsRouteWithChildren
  LibraryRoute: typeof LibraryRouteWithChildren
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SettingsRoute: typeof SettingsRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  TeamManagerRoute: typeof TeamManagerRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  WelcomeRoute: typeof WelcomeRoute
  DevLessonsRoute: typeof DevLessonsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-manager': {
      id: '/team-manager'
      path: '/team-manager'
      fullPath: '/team-manager'
      preLoaderRoute: typeof TeamManagerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lessons': {
      id: '/lessons'
      path: '/lessons'
      fullPath: '/lessons'
      preLoaderRoute: typeof LessonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenges': {
      id: '/challenges'
      path: '/challenges'
      fullPath: '/challenges'
      preLoaderRoute: typeof ChallengesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/': {
      id: '/library/'
      path: '/'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/lessons/': {
      id: '/lessons/'
      path: '/'
      fullPath: '/lessons/'
      preLoaderRoute: typeof LessonsIndexRouteImport
      parentRoute: typeof LessonsRoute
    }
    '/challenges/': {
      id: '/challenges/'
      path: '/'
      fullPath: '/challenges/'
      preLoaderRoute: typeof ChallengesIndexRouteImport
      parentRoute: typeof ChallengesRoute
    }
    '/library/$moduleSlug': {
      id: '/library/$moduleSlug'
      path: '/$moduleSlug'
      fullPath: '/library/$moduleSlug'
      preLoaderRoute: typeof LibraryModuleSlugRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/lessons/$slug': {
      id: '/lessons/$slug'
      path: '/$slug'
      fullPath: '/lessons/$slug'
      preLoaderRoute: typeof LessonsSlugRouteImport
      parentRoute: typeof LessonsRoute
    }
    '/dev/lessons': {
      id: '/dev/lessons'
      path: '/dev/lessons'
      fullPath: '/dev/lessons'
      preLoaderRoute: typeof DevLessonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenges/$pageSlug': {
      id: '/challenges/$pageSlug'
      path: '/$pageSlug'
      fullPath: '/challenges/$pageSlug'
      preLoaderRoute: typeof ChallengesPageSlugRouteImport
      parentRoute: typeof ChallengesRoute
    }
    '/dev/lessons/': {
      id: '/dev/lessons/'
      path: '/'
      fullPath: '/dev/lessons/'
      preLoaderRoute: typeof DevLessonsIndexRouteImport
      parentRoute: typeof DevLessonsRoute
    }
    '/dev/lessons/$category/$slug': {
      id: '/dev/lessons/$category/$slug'
      path: '/$category/$slug'
      fullPath: '/dev/lessons/$category/$slug'
      preLoaderRoute: typeof DevLessonsCategorySlugRouteImport
      parentRoute: typeof DevLessonsRoute
    }
  }
}

interface ChallengesRouteChildren {
  ChallengesPageSlugRoute: typeof ChallengesPageSlugRoute
  ChallengesIndexRoute: typeof ChallengesIndexRoute
}

const ChallengesRouteChildren: ChallengesRouteChildren = {
  ChallengesPageSlugRoute: ChallengesPageSlugRoute,
  ChallengesIndexRoute: ChallengesIndexRoute,
}

const ChallengesRouteWithChildren = ChallengesRoute._addFileChildren(
  ChallengesRouteChildren,
)

interface LessonsRouteChildren {
  LessonsSlugRoute: typeof LessonsSlugRoute
  LessonsIndexRoute: typeof LessonsIndexRoute
}

const LessonsRouteChildren: LessonsRouteChildren = {
  LessonsSlugRoute: LessonsSlugRoute,
  LessonsIndexRoute: LessonsIndexRoute,
}

const LessonsRouteWithChildren =
  LessonsRoute._addFileChildren(LessonsRouteChildren)

interface LibraryRouteChildren {
  LibraryModuleSlugRoute: typeof LibraryModuleSlugRoute
  LibraryIndexRoute: typeof LibraryIndexRoute
}

const LibraryRouteChildren: LibraryRouteChildren = {
  LibraryModuleSlugRoute: LibraryModuleSlugRoute,
  LibraryIndexRoute: LibraryIndexRoute,
}

const LibraryRouteWithChildren =
  LibraryRoute._addFileChildren(LibraryRouteChildren)

interface DevLessonsRouteChildren {
  DevLessonsIndexRoute: typeof DevLessonsIndexRoute
  DevLessonsCategorySlugRoute: typeof DevLessonsCategorySlugRoute
}

const DevLessonsRouteChildren: DevLessonsRouteChildren = {
  DevLessonsIndexRoute: DevLessonsIndexRoute,
  DevLessonsCategorySlugRoute: DevLessonsCategorySlugRoute,
}

const DevLessonsRouteWithChildren = DevLessonsRoute._addFileChildren(
  DevLessonsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivateRoute: ActivateRoute,
  AdminRoute: AdminRoute,
  ChallengesRoute: ChallengesRouteWithChildren,
  LessonsRoute: LessonsRouteWithChildren,
  LibraryRoute: LibraryRouteWithChildren,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SettingsRoute: SettingsRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TeamManagerRoute: TeamManagerRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  WelcomeRoute: WelcomeRoute,
  DevLessonsRoute: DevLessonsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
